import React from "react";
import { Redirect } from "react-router";
import { useSelector } from "react-redux";
import RouteWithTransition from "./RouteWithTransition";

export default function PrivateRoute({ component: Component, type, ...rest }) {
  const currentAuthType = useSelector((state) => (state.auth.profile ? state.auth.profile.type : undefined));
  return <RouteWithTransition {...rest} component={currentAuthType === type ? Component : () => <Redirect to="/" />} />;
}
